function resolveDomain() {
    if (window.Capacitor?.isNativePlatform?.()) {
        return "https://my.intilly.com";
    }
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    const port = window.location.port;
    return `${protocol}//${hostname}${port ? ':' + port : ''}`;
}
export const domain = resolveDomain();


export const URLS = {
    DOMAIN: domain,
    AUTH: {
        SIGN_IN_URL: `${domain}/api/auth/sign-in/`,
        SIGN_OUT_URL: `${domain}/api/auth/sign-out/`,
        SIGN_UP_URL: `${domain}/api/auth/sign-up/`,
        DELETE_ACCOUNT_URL: `${domain}/api/auth/delete/`,
        RESET_PASSWORD_START_URL: `${domain}/api/auth/change/password/start/`,
        RESET_PASSWORD_FINAL_URL: `${domain}/api/auth/change/password/final/`,
        CHANGE_EMAIL_START_URL: `${domain}/api/auth/change/email/start/`,
        CHANGE_EMAIL_CONTINUE_URL: `${domain}/api/auth/change/email/continue/`,
        CHANGE_EMAIL_FINAL_URL: `${domain}/api/auth/change/email/final/`,
        CHANGE_PHONE_START_URL: `${domain}/api/auth/change/phone/start/`,
        CHANGE_PHONE_FINAL_URL: `${domain}/api/auth/change/phone/final/`,
        CONFIRMATION_ACCOUNT_URL: `${domain}/api/auth/confirm/`,
        CHECK_AUTHENTICATION_URL: `${domain}/api/auth/check/authentication/`,
        CHECK_TEMPORARY_TOKEN_URL: `${domain}/api/auth/check/temporary-token/`,
        GET_CSRF_TOKEN: `${domain}/api/auth/get-csrf-token/`,
    },
    PAY: {
        CREATE_PAYMENT_URL: `${domain}/api/pay/create-payment-url/`,
        GO_TO_FREE_PLAN_URL: `${domain}/api/pay/go-to-free-plan/`,
    },
    MODEL: {
        ACCOUNT: {
            PERSONAL_DATA_URL: `${domain}/api/model/personal/data/`,
            PERSONAL_STAFF_DATA_URL: `${domain}/api/model/personal/staff-data/`,
            PUSH_SUBSCRIPTION_URL: `${domain}/api/model/push-subscription/`,
        },
        COMPANY: {
            COMPANY_LOGO_URL: `${domain}/api/model/company/logo/`,
            COMPANY_URL: `${domain}/api/model/company/data/`,
            COMPANIES_URL: `${domain}/api/model/companies/`,
            CHARACTERISTICS_URL: `${domain}/api/model/company/characteristics/`,
            COMPANY_DISCOUNT_POLICY_URL: `${domain}/api/model/company/discount-policy/`,
            COMPANY_DISPLAYED_COLUMNS_URL: `${domain}/api/model/company/displayed-columns/`,
        },
        SHOP: {
            SHOPS_URL: `${domain}/api/model/shops/`,
            SHOP_URL: `${domain}/api/model/shop/<ID>/`,
            SUGGEST_CITY_URL: `${domain}/api/model/suggest-city/`,
        },
        GOOD: {
            GOODS_URL: `${domain}/api/model/goods/`,
            GOODS_LINK_URL: `${domain}/api/model/goods/link/`,
            GOOD_URL: `${domain}/api/model/good/<ID>/`,
        },
        GOOD_CATEGORY: {
            GOOD_CATEGORIES_URL: `${domain}/api/model/good-categories/`,
            GOOD_CATEGORY_URL: `${domain}/api/model/good-category/<ID>/`,
        },
        CLIENT: {
            CLIENTS_URL: `${domain}/api/model/clients/`,
            CLIENT_URL: `${domain}/api/model/client/<ID>/`,
            CLIENT_HISTORY_URL: `${domain}/api/model/client/<ID>/history/`,
            SEND_MESSAGE_URL: `${domain}/api/model/clients/send-message/`,
            NOTIFICATION_LOGS_URL: `${domain}/api/model/notification-logs/`,
        },
        CSV: {
            TRANSACTION_CSV_URL: `${domain}/api/model/csv/transactions/`,
            GOOD_CSV_URL: `${domain}/api/model/csv/goods/`,
            CLIENT_CSV_URL: `${domain}/api/model/csv/clients/`,
        },
        TASK: {
            TASKS_URL: `${domain}/api/model/tasks/`,
            TASK_URL: `${domain}/api/model/task/<ID>/`,
        },
        INVOICE: {
            INVOICES_URL: `${domain}/api/model/invoices/`,
            INVOICE_URL: `${domain}/api/model/invoice/<ID>/`,
            REQUISITES_URL: `${domain}/api/model/invoice/requisites/`,
        },
        STAFF: {
            STAFFS_URL: `${domain}/api/model/staffs/`,
            STAFF_URL: `${domain}/api/model/staff/<ID>/`,
            CASHIERS_URL: `${domain}/api/model/cashiers/`,
        },
        SUPPLY: {
            SUPPLIES_URL: `${domain}/api/model/supplies/`,
            SUPPLY_URL: `${domain}/api/model/supply/<ID>/`,
        },
        WAREHOUSE_MOVE: {
            WAREHOUSE_MOVES_URL: `${domain}/api/model/warehouse-moves/`,
            WAREHOUSE_MOVE_URL: `${domain}/api/model/warehouse-move/<ID>/`,
        },
        WAREHOUSE_MOVE_AND_SUPPLY: {
            WAREHOUSE_MOVES_AND_SUPPLIES_URL: `${domain}/api/model/warehouse-moves-and-supplies/`,
        },
        SALE: {
            SALES_URL: `${domain}/api/model/sales/`,
            SALES_SEARCH_URL: `${domain}/api/model/sales/search/`,
            SALE_URL: `${domain}/api/model/sale/<ID>/`,
            BALANCE_SUMMARY_URL: `${domain}/api/model/sales/balance-summary/`,
            DASHBOARD_SUMMARY_URL: `${domain}/api/model/sales/dashboard-summary/`,
            SALES_STREAM_URL: `${domain}/api/model/sales/stream/`,
        },
        TRANSFER: {
            TRANSFERS_URL: `${domain}/api/model/transfers/`,
        },
        SALARY_REPORT: {
            SALARY_REPORTS_URL: `${domain}/api/model/salary-reports/`,
        },
        PAYOUT: {
            PAYOUT_URL: `${domain}/api/model/payout/<ID>/`,
            PAYOUTS_URL: `${domain}/api/model/payouts/`,
        },
        ACCRUAL: {
            ACCRUAL_URL: `${domain}/api/model/accrual/<ID>/`,
            ACCRUALS_URL: `${domain}/api/model/accruals/`,
        },
        SCHEDULE: {
            SCHEDULES_URL: `${domain}/api/model/schedules/`,
        },
        STAFF_SERVICE: {
            STAFF_SERVICES_URL: `${domain}/api/model/staff-services/`,
        },
        PROMO_CODE: {
            PROMO_CODE_URL: `${domain}/api/model/promo-code/`,
        },
        STATISTICS: {
            SALES_SUMMARY_URL: `${domain}/api/model/statistics/sales-summary/`,
            ANALYTICS_URL: `${domain}/api/model/statistics/analytics/`,
            STAFF_PERFORMANCE_URL: `${domain}/api/model/statistics/staff-performance/`,
        },
        APPOINTMENT: {
            LIST_URL: `${domain}/api/model/appointments/`,
            DETAIL_URL: (pk) => `${domain}/api/model/appointment/${pk}/`,
            STREAM_URL: `${domain}/api/model/appointments/stream/`,
        },
    },
    PUBLIC_BOOKING: {
        INFO_URL: (token) => `${domain}/api/public/booking/${token}/info/`,
        STAFF_URL: (token) => `${domain}/api/public/booking/${token}/staff/`,
        SERVICES_URL: (token) => `${domain}/api/public/booking/${token}/services/`,
        SLOTS_URL: (token) => `${domain}/api/public/booking/${token}/slots/`,
        BOOK_URL: (token) => `${domain}/api/public/booking/${token}/book/`,
        CANCEL_URL: (token, cancelToken) => `${domain}/api/public/booking/${token}/cancel/${cancelToken}/`,
        CONFIRM_URL: (token, confirmToken) => `${domain}/api/public/booking/${token}/confirm/${confirmToken}/`,
    },
    BOOKING_SETTINGS: {
        URL: `${domain}/api/model/company/booking-settings/`,
    },
    AI_CONCIERGE: {
        SETTINGS_URL: `${domain}/api/model/ai-concierge/settings/`,
        SESSIONS_URL: `${domain}/api/model/ai-concierge/sessions/`,
        SESSION_URL: `${domain}/api/model/ai-concierge/session/<ID>/`,
        UNANSWERED_URL: `${domain}/api/model/ai-concierge/unanswered/`,
    },
};


export const UPDATE_DATA_INTERVAL = 15 * 60 * 1000;


export const DEFAULT_PAYMENT_METHODS = ["cash", "card", "terminal", "account"];


export const RESPONSES = {
    SUCCESSFULLY: "Successfully.",
    NOT_VALID: "Not valid.",
    NOT_FOUND: "Not found.",
    IS_ALREADY_DONE: "Already done.",
    ALREADY_EXIST: "Already exist.",
    TOO_MANY_REQUESTS_IN_SHORT_TIME: "Too many request in short time.",
};


export const CURRENCIES = ["USD", "RUB", "EUR", "BYN", "KZT", "UZS", "CNY", "AZN", "TRY", "GEL", "THB"];


export const ROLES = {
    STAFF: "staff",
    FOUNDER: "founder",
}


export const PAYMENTS = {
    CASH: "cash",
}


export const GOOD_FORMATS = {
    GOOD: "good",
    OPERATION: "operation",
    SERVICE: "service",
}


export const  PLANS = {
    FREE: "free",
    MONTHLY: "monthly",
    ANNUAL: "annual",
};


export const DRAG_MODES = {
    AFTER: "after",
    BEFORE: "before",
}


export const TRANSACTION_TYPE = {
    INCOME: "income",
}


export const SALARY_TYPES = {
    SALARY_PER_DAY_SHIFT: "salaryPerDayShift",
    SALARY_PER_DAY_HOUR: "salaryPerDayHour",
    SALARY_PER_NIGHT_SHIFT: "salaryPerNightShift",
    SALARY_PER_NIGHT_HOUR: "salaryPerNightHour",
    SALARY_PER_VACATION_DAY: "salaryPerVacationDay",
};


export const LABELS = {
    TRANSACTION_METHODS: {
        "cash": "Cash",
        "card": "Card",
        "terminal": "Terminal",
        "account": "Bank account",
    },
    CURRENCIES: {
        "RUB": "₽",
        "USD": "$",
        "EUR": "€",
        "BYN": "Br",
        "KZT": "₸",
        "UZS": "S",
        "CNY": "¥",
        "AZN": "₼",
        "TRY": "₺",
        "GEL": "₾",
        "THB": "฿",
    },
    GOOD_FORMATS: {
        "good": "Product",
        "service": "Service",
        "operation": "Operation",
    },
    JOB_TITLES: {
        "manager": "Менеджер",
        "cashier": "Кассир",
    },
    SALARY_TYPES: {
        "salaryPerDayShift": "Day shift rate",
        "salaryPerDayHour": "Day hourly rate",
        "salaryPerNightShift": "Night shift rate",
        "salaryPerNightHour": "Night hourly rate",
        "salaryPerVacationDay": "Vacation day rate",
    },
    PLANS: {
        "free": "Free",
        "monthly": "Monthly",
        "annual": "Annual",
    },
    PLAN_PERIOD: {
        "monthly": "month",
        "annual": "year"
    },
    PAYOUT_TYPES: {
        "salary": "Salary",
        "advance": "Advance",
        "vacation": "Vacation",
        "sick": "Sick",
        "penalty": "Penalty",
    },
    MONTHS: {
        "01": "January",
        "02": "February",
        "03": "March",
        "04": "April",
        "05": "May",
        "06": "June",
        "07": "July",
        "08": "August",
        "09": "September",
        "10": "October",
        "11": "November",
        "12": "December",
    },
    SCHEDULE: {
        "day shift": "Д",
        "night shift": "Н",
        "absence": "П",
        "sick leave": "Б",
        "vacation": "О",
    }
};


export const START_DATE_OF_SALARY_AND_SCHEDULE_PLUGIN = "2025-02-01";
export const MAX_AMOUNT_OF_TRANSACTIONS_BY_DAY_FOR_FREE_PLAN = 10;

export const CITY_TIMEZONES = {
    "en": {
        "Moscow": "Europe/Moscow",
        "Saint Petersburg": "Europe/Moscow",
        "Yekaterinburg": "Asia/Yekaterinburg",
        "Kazan": "Europe/Moscow",
        "Novosibirsk": "Asia/Novosibirsk",
        "Krasnoyarsk": "Asia/Krasnoyarsk",
        "Chelyabinsk": "Asia/Yekaterinburg",
        "Omsk": "Asia/Omsk",
        "Samara": "Europe/Samara",
        "Rostov-on-Don": "Europe/Moscow",
        "Ufa": "Asia/Yekaterinburg",
        "Krasnodar": "Europe/Moscow",
        "Perm": "Asia/Yekaterinburg",
        "Vladivostok": "Asia/Vladivostok",
        "Irkutsk": "Asia/Irkutsk",
        "Yaroslavl": "Europe/Moscow",
        "Voronezh": "Europe/Moscow",
        "Makhachkala": "Europe/Moscow",
        "Tomsk": "Asia/Novosibirsk",
        "Orenburg": "Europe/Samara",
        "Kemerovo": "Asia/Novokuznetsk",
        "Tyumen": "Asia/Yekaterinburg",
        "Volgograd": "Europe/Volgograd",
        "Astrakhan": "Europe/Astrakhan",
        "Kirov": "Europe/Moscow",
        "Izhevsk": "Europe/Samara",
        "Ulyanovsk": "Europe/Ulyanovsk",
        "Barnaul": "Asia/Novosibirsk",
        "Vladimir": "Europe/Moscow",
        "Kaliningrad": "Europe/Kaliningrad",
        "Nalchik": "Europe/Moscow",
        "Khabarovsk": "Asia/Vladivostok",
        "Stavropol": "Europe/Moscow",
        "Belgorod": "Europe/Moscow",
        "Khanty-Mansiysk": "Asia/Yekaterinburg",
        "Surgut": "Asia/Yekaterinburg",
        "Cheboksary": "Europe/Moscow",
        "Petrozavodsk": "Europe/Moscow",
        "Kurgan": "Asia/Yekaterinburg",
        "Veliky Novgorod": "Europe/Moscow",
        "Kostroma": "Europe/Moscow",
        "Yoshkar-Ola": "Europe/Moscow",
        "Saransk": "Europe/Moscow",
        "Yakutsk": "Asia/Yakutsk",
        "Vladikavkaz": "Europe/Moscow",
        "Simferopol": "Europe/Simferopol",
        "Kursk": "Europe/Moscow",
        "Murmansk": "Europe/Moscow",
        "Tambov": "Europe/Moscow",
        "Grozny": "Europe/Moscow",
        "Tver": "Europe/Moscow",
        "Tula": "Europe/Moscow",
        "Blagoveshchensk": "Asia/Yakutsk",
        "Chita": "Asia/Chita",
        "Pskov": "Europe/Moscow",
        "Bryansk": "Europe/Moscow",
        "Ryazan": "Europe/Moscow",
        "Arkhangelsk": "Europe/Moscow",
        "Lipetsk": "Europe/Moscow",
        "Magadan": "Asia/Magadan",
        "Gorno-Altaysk": "Asia/Omsk",
        "Syktyvkar": "Europe/Moscow",
        "Smolensk": "Europe/Moscow",
        "Birobidzhan": "Asia/Vladivostok",
        "Petropavlovsk-Kamchatsky": "Asia/Kamchatka",
        "Abakan": "Asia/Krasnoyarsk",
        "Sevastopol": "Europe/Simferopol",
        "Anadyr": "Asia/Anadyr",
        "Salekhard": "Asia/Yekaterinburg",
        "Abidjan": "Africa/Abidjan",
        "Accra": "Africa/Accra",
        "Addis Ababa": "Africa/Addis_Ababa",
        "Algeria": "Africa/Algiers",
        "Asmara": "Africa/Asmara",
        "Bamako": "Africa/Bamako",
        "Bangui": "Africa/Bangui",
        "Banjul": "Africa/Banjul",
        "Bissau": "Africa/Bissau",
        "Blantyre": "Africa/Blantyre",
        "Brazzaville": "Africa/Brazzaville",
        "Bujumbura": "Africa/Bujumbura",
        "Cairo": "Africa/Cairo",
        "Casablanca": "Africa/Casablanca",
        "Ceuta": "Africa/Ceuta",
        "Conakry": "Africa/Conakry",
        "Dakar": "Africa/Dakar",
        "Dar es Salaam": "Africa/Dar_es_Salaam",
        "Djibouti": "Africa/Djibouti",
        "Douala": "Africa/Douala",
        "Laayoune": "Africa/El_Aaiun",
        "Freetown": "Africa/Freetown",
        "Gaborone": "Africa/Gaborone",
        "Harare": "Africa/Harare",
        "Johannesburg": "Africa/Johannesburg",
        "Juba": "Africa/Juba",
        "Kampala": "Africa/Kampala",
        "Khartoum": "Africa/Khartoum",
        "Kigali": "Africa/Kigali",
        "Kinshasa": "Africa/Kinshasa",
        "Lagos": "Africa/Lagos",
        "Libreville": "Africa/Libreville",
        "Lomé": "Africa/Lome",
        "Luanda": "Africa/Luanda",
        "Lubumbashi": "Africa/Lubumbashi",
        "Lusaka": "Africa/Lusaka",
        "Malabo": "Africa/Malabo",
        "Maputo": "Africa/Maputo",
        "Maseru": "Africa/Maseru",
        "Mbabane": "Africa/Mbabane",
        "Mogadishu": "Africa/Mogadishu",
        "Monrovia": "Africa/Monrovia",
        "Nairobi": "Africa/Nairobi",
        "N'Djamena": "Africa/Ndjamena",
        "Niamey": "Africa/Niamey",
        "Nouakchott": "Africa/Nouakchott",
        "Ouagadougou": "Africa/Ouagadougou",
        "Porto-Novo": "Africa/Porto-Novo",
        "San José": "Africa/Sao_Tome",
        "Timbuktu": "Africa/Timbuktu",
        "Tripoli": "Africa/Tripoli",
        "Tunisia": "Africa/Tunis",
        "Windhoek": "Africa/Windhoek",
        "Adak": "America/Adak",
        "Anchorage": "America/Anchorage",
        "Anguilla": "America/Anguilla",
        "Antigua": "America/Antigua",
        "Araguaína": "America/Araguaina",
        "Buenos Aires": "America/Argentina/Buenos_Aires",
        "Catamarca": "America/Argentina/Catamarca",
        "Comodoro Rivadavia": "America/Argentina/ComodRivadavia",
        "Córdoba": "America/Argentina/Cordoba",
        "San Salvador de Jujuy": "America/Argentina/Jujuy",
        "Logroño": "America/Argentina/La_Rioja",
        "Mendoza": "America/Argentina/Mendoza",
        "Río Gallegos": "America/Argentina/Rio_Gallegos",
        "Salta": "America/Argentina/Salta",
        "San Juan": "America/Argentina/San_Juan",
        "San Luis Potosí City": "America/Argentina/San_Luis",
        "Tucumán": "America/Argentina/Tucuman",
        "Aruba": "America/Aruba",
        "Asunción": "America/Asuncion",
        "Atikokan Municipal Airport": "America/Atikokan",
        "Bahía Blanca": "America/Bahia",
        "Bahía de Banderas": "America/Bahia_Banderas",
        "Barbados": "America/Barbados",
        "Belém": "America/Belem",
        "Belize": "America/Belize",
        "Lourdes-de-Blanc-Sablon Airport": "America/Blanc-Sablon",
        "Boa Vista": "America/Boa_Vista",
        "Bogotá": "America/Bogota",
        "Boise": "America/Boise",
        "Campo Grande": "America/Campo_Grande",
        "Cancún": "America/Cancun",
        "Caracas": "America/Caracas",
        "Cayenne": "America/Cayenne",
        "Little Cayman": "America/Cayman",
        "Chicago": "America/Chicago",
        "Chihuahua City": "America/Chihuahua",
        "Ciudad Juárez": "America/Ciudad_Juarez",
        "Costa Rica": "America/Costa_Rica",
        "Crestone": "America/Creston",
        "Cuiabá": "America/Cuiaba",
        "Curaçao": "America/Curacao",
        "Jim Kelly Field": "America/Dawson",
        "Denver": "America/Denver",
        "Detroit": "America/Detroit",
        "Dominica": "America/Dominica",
        "Edmonton": "America/Edmonton",
        "San Salvador": "America/El_Salvador",
        "Ensenada": "America/Ensenada",
        "Goodwin Fort Historical Marker": "America/Fort_Nelson",
        "Fort Wayne": "America/Fort_Wayne",
        "Fortaleza": "America/Fortaleza",
        "Nuuk": "America/Godthab",
        "Grand Turk": "America/Grand_Turk",
        "Grenada": "America/Grenada",
        "Guadeloupe": "America/Guadeloupe",
        "Guatemala": "America/Guatemala",
        "Guayaquil": "America/Guayaquil",
        "Guyana": "America/Guyana",
        "Halifax": "America/Halifax",
        "Havana": "America/Havana",
        "Hermosillo": "America/Hermosillo",
        "Indianapolis": "America/Indiana/Indianapolis",
        "Vincennes": "America/Indiana/Knox",
        "Marengo": "America/Indiana/Marengo",
        "Tell City": "America/Indiana/Tell_City",
        "Inuvik (Mike Zubko) Airport": "America/Inuvik",
        "Iqaluit": "America/Iqaluit",
        "Jamaica": "America/Jamaica",
        "Juneau": "America/Juneau",
        "Louisville": "America/Kentucky/Louisville",
        "Kralendijk": "America/Kralendijk",
        "La Paz": "Mexico/BajaSur",
        "Lima": "America/Lima",
        "Los Angeles": "America/Los_Angeles",
        "Maceió": "America/Maceio",
        "Managua": "America/Managua",
        "Manaus": "America/Manaus",
        "Marigot": "America/Marigot",
        "Martinique": "America/Martinique",
        "Heroica Matamoros": "America/Matamoros",
        "Mazatlán": "America/Mazatlan",
        "Menominee": "America/Menominee",
        "Merida": "America/Merida",
        "Metlakatla": "America/Metlakatla",
        "Mexico City": "America/Mexico_City",
        "Saint Pierre and Miquelon": "America/Miquelon",
        "Moncton": "America/Moncton",
        "Monterrey": "America/Monterrey",
        "Montevideo": "America/Montevideo",
        "Montreal": "America/Montreal",
        "Montserrat": "America/Montserrat",
        "Nassau": "America/Nassau",
        "New York": "America/New_York",
        "Lake Nipigon": "America/Nipigon",
        "Phnom Penh": "Asia/Phnom_Penh",
        "New Salem": "America/North_Dakota/New_Salem",
        "Panama": "America/Panama",
        "Pangnirtung Airport": "America/Pangnirtung",
        "Paramaribo": "America/Paramaribo",
        "Phoenix": "America/Phoenix",
        "Port-au-Prince": "America/Port-au-Prince",
        "Port of Spain": "America/Port_of_Spain",
        "Porto Velho": "America/Porto_Velho",
        "Puerto Rico": "America/Puerto_Rico",
        "Punta Arenas": "America/Punta_Arenas",
        "Rainy Lake": "America/Rainy_River",
        "Rankin Inlet Airport": "America/Rankin_Inlet",
        "Recife": "America/Recife",
        "Regina": "America/Regina",
        "Resolute": "America/Resolute",
        "Rio Branco": "America/Rio_Branco",
        "Rosario": "America/Rosario",
        "Santa Izabel do Oeste": "America/Santa_Isabel",
        "Santarém": "America/Santarem",
        "Santiago": "America/Santiago",
        "Santo Domingo": "America/Santo_Domingo",
        "São Paulo": "America/Sao_Paulo",
        "Ittoqqortoormiit": "America/Scoresbysund",
        "Shiprock": "America/Shiprock",
        "Sitka": "America/Sitka",
        "Saint Barthélemy": "America/St_Barthelemy",
        "St John's": "America/St_Johns",
        "St Peter Port": "America/St_Vincent",
        "Saint Lucia": "America/St_Lucia",
        "Saint Thomas": "America/St_Thomas",
        "Swift Current": "America/Swift_Current",
        "Tegucigalpa": "America/Tegucigalpa",
        "El Tule Municipality": "America/Thule",
        "Thunder Bay": "America/Thunder_Bay",
        "Tijuana": "America/Tijuana",
        "Toronto": "America/Toronto",
        "Tortola": "America/Tortola",
        "Vancouver": "America/Vancouver",
        "British Virgin Islands": "America/Virgin",
        "Whitehorse": "America/Whitehorse",
        "Winnipeg": "America/Winnipeg",
        "Yakutat Seamount": "America/Yakutat",
        "Yellowknife": "America/Yellowknife",
        "Casey": "Antarctica/Casey",
        "Davis": "Antarctica/Davis",
        "Port Macquarie": "Antarctica/Macquarie",
        "Mawson Peak": "Antarctica/Mawson",
        "McMurdo Sound": "Antarctica/McMurdo",
        "Palmer Station": "Antarctica/Palmer",
        "South Pole": "Antarctica/South_Pole",
        "Troll research station": "Antarctica/Troll",
        "Vostok": "Antarctica/Vostok",
        "Longyearbyen": "Arctic/Longyearbyen",
        "Aden": "Asia/Aden",
        "Almaty": "Asia/Almaty",
        "Amman": "Asia/Amman",
        "Aktau": "Asia/Aqtau",
        "Aktobe": "Asia/Aqtobe",
        "Ashgabat": "Asia/Ashgabat",
        "Atyrau": "Asia/Atyrau",
        "Baghdad": "Asia/Baghdad",
        "Bahrain": "Asia/Bahrain",
        "Baku": "Asia/Baku",
        "Bangkok": "Asia/Bangkok",
        "Beirut": "Asia/Beirut",
        "Bishkek": "Asia/Bishkek",
        "Brunei": "Asia/Brunei",
        "Kolkata": "Asia/Kolkata",
        "Choibalsan Airport": "Asia/Choibalsan",
        "Chongqing": "Asia/Chongqing (Chungking)",
        "Colombo": "Asia/Colombo",
        "Dhaka": "Asia/Dhaka",
        "Damascus": "Asia/Damascus",
        "Dili": "Asia/Dili",
        "Dubai": "Asia/Dubai",
        "Dushanbe": "Asia/Dushanbe",
        "Famagusta": "Asia/Famagusta",
        "Gaza": "Asia/Gaza",
        "Harbin": "Asia/Harbin",
        "Hebron": "Asia/Hebron",
        "Ho Chi Minh City": "Asia/Ho_Chi_Minh",
        "Hong Kong": "Asia/Hong_Kong",
        "Khovd": "Asia/Hovd",
        "Istanbul": "Asia/Istanbul",
        "Jakarta": "Asia/Jakarta",
        "Jayapura": "Asia/Jayapura",
        "Jerusalem": "Asia/Jerusalem",
        "Kabul": "Asia/Kabul",
        "Kamchatka": "Asia/Kamchatka",
        "Karachi": "Asia/Karachi",
        "Kashgar": "Asia/Kashgar",
        "Kathmandu": "Asia/Kathmandu",
        "Khandyga": "Asia/Khandyga",
        "Kuala Lumpur": "Asia/Kuala_Lumpur",
        "Kuching": "Asia/Kuching",
        "Kuwait": "Asia/Kuwait",
        "Macao": "Asia/Macao (Macau)",
        "Makassar": "Asia/Makassar",
        "Manila": "Asia/Manila",
        "Muscat": "Asia/Muscat",
        "Nicosia": "Asia/Nicosia",
        "Novokuznetsk": "Asia/Novokuznetsk",
        "Oral": "Asia/Oral",
        "Pontianak": "Asia/Pontianak",
        "Pyongyang": "Asia/Pyongyang",
        "Qatar": "Asia/Qatar",
        "Kostanay": "Asia/Qostanay (Kostanay)",
        "Kyzylorda": "Asia/Qyzylorda",
        "Yangon": "Asia/Rangoon (Yangon)",
        "Riyadh": "Asia/Riyadh",
        "Sakhalin Oblast": "Asia/Sakhalin",
        "Samarkand": "Asia/Samarkand",
        "Seoul": "Asia/Seoul",
        "Shanghai": "Asia/Shanghai",
        "Singapore": "Asia/Singapore",
        "Srednekolymsk Airport": "Asia/Srednekolymsk",
        "Banciao": "Asia/Taipei",
        "Tashkent": "Asia/Tashkent",
        "Tbilisi": "Asia/Tbilisi",
        "Tehran": "Asia/Tehran",
        "Thimphu": "Asia/Thimbu (Thimphu)",
        "Tokyo": "Asia/Tokyo",
        "Ulaanbaatar": "Asia/Ulaanbaatar (Ulan Bator)",
        "Ürümqi": "Asia/Urumqi",
        "Ust-Nera Airport": "Asia/Ust-Nera",
        "Vientiane": "Asia/Vientiane",
        "Yerevan": "Asia/Yerevan",
        "Azores": "Atlantic/Azores",
        "Bermuda": "Atlantic/Bermuda",
        "Las Palmas de Gran Canaria": "Atlantic/Canary",
        "Cabo Verde": "Atlantic/Cape_Verde",
        "Faroe Islands": "Atlantic/Faeroe (Faroe)",
        "Beerenberg": "Atlantic/Jan_Mayen",
        "Funchal": "Atlantic/Madeira",
        "Reykjavik": "Atlantic/Reykjavik",
        "Southern Asia": "Atlantic/South_Georgia",
        "Stanley": "Atlantic/Stanley",
        "Adelaide": "Australia/Adelaide",
        "Brisbane": "Australia/Brisbane",
        "Broken Hill": "Australia/Broken_Hill",
        "Tal-Karri": "Australia/Currie",
        "Darwin": "Australia/Darwin",
        "Jukla Shāh Khāngah": "Australia/Eucla",
        "Hobart": "Australia/Hobart",
        "Lindeman Islands National Park": "Australia/Lindeman",
        "Lord Howe Rise": "Australia/Lord_Howe",
        "Melbourne": "Australia/Melbourne",
        "Perth": "Australia/Perth",
        "Sydney": "Australia/Sydney",
        "Ákra Ákri": "Brazil/Acre",
        "Saskatchewan": "Canada/Saskatchewan",
        "Yukon": "Canada/Yukon",
        "Easter Island": "Chile/EasterIsland",
        "Cuba": "Cuba",
        "Egypt": "Egypt",
        "Ireland": "Eire",
        "Iceland": "Iceland",
        "Antananarivo": "Indian/Antananarivo",
        "Chagos Trench": "Indian/Chagos",
        "Kiritimati": "Pacific/Kiritimati",
        "Cocos": "Indian/Cocos",
        "Kerguelen Plateau": "Indian/Kerguelen",
        "Mahé": "Indian/Mahe",
        "Maldives": "Indian/Maldives",
        "Mauritius": "Indian/Mauritius",
        "Mayotte": "Indian/Mayotte",
        "Réunion": "Indian/Reunion",
        "Iran": "Iran",
        "Israel": "Israel",
        "Japan": "Japan",
        "Libya": "Libya",
        "New Zealand": "NZ",
        "Show Low": "Navajo",
        "Apia": "Pacific/Apia",
        "Auckland": "Pacific/Auckland",
        "Bougainville Island": "Pacific/Bougainville",
        "Savannah": "Pacific/Chatham",
        "Weno": "Pacific/Chuuk (Truk)",
        "Efate": "Pacific/Efate",
        "Fakaofo": "Pacific/Fakaofo",
        "Fiji": "Pacific/Fiji",
        "Funafuti": "Pacific/Funafuti",
        "Malango": "Pacific/Guadalcanal",
        "Guam": "Pacific/Guam",
        "Honolulu": "Pacific/Honolulu",
        "Johnston Atoll": "Pacific/Johnston",
        "Sarajevo": "Pacific/Kanton",
        "Tofol": "Pacific/Kosrae",
        "Majuro": "Pacific/Majuro",
        "Midway Atoll": "Pacific/Midway",
        "Nauru": "Pacific/Nauru",
        "Niue": "Pacific/Niue",
        "Norfolk Island": "Pacific/Norfolk",
        "Noumea": "Pacific/Noumea",
        "Pago Pago": "Pacific/Pago_Pago",
        "Palau": "Pacific/Palau",
        "Pitcairn Islands": "Pacific/Pitcairn",
        "Kolonia": "Pacific/Pohnpei (Ponape)",
        "Port Moresby": "Pacific/Port_Moresby",
        "Rarotonga": "Pacific/Rarotonga",
        "Saipan": "Pacific/Saipan",
        "Samoa": "Pacific/Samoa",
        "Tahiti": "Pacific/Tahiti",
        "Tarawa": "Pacific/Tarawa",
        "Lapaha": "Pacific/Tongatapu",
        "Wake Island": "Pacific/Wake",
        "Wallis and Futuna": "Pacific/Wallis",
        "Colonia": "Pacific/Yap",
        "Poland": "Poland",
        "Portugal": "Portugal",
        "Türkiye": "Turkey",
        "Brazil (Eastern part)": "Brazil/East",
        "Brazil (Western part)": "Brazil/West",
        "Canada (Atlantic Time Zone)": "Canada/Atlantic",
        "Canada (Central Time Zone)": "Canada/Central",
        "Canada (Eastern Time Zone)": "Canada/Eastern",
        "Canada (Mountain Time Zone)": "Canada/Mountain",
        "Canada (Pacific Time Zone)": "Canada/Pacific",
        "Chile (Continental part)": "Chile/Continental",
        "Alaska (USA)": "US/Alaska",
        "Aleutian Islands (USA)": "US/Aleutian",
        "Arizona (USA)": "US/Arizona",
        "Central Time Zone (USA)": "US/Central",
        "Eastern Indiana (USA)": "US/East-Indiana",
        "Eastern Time Zone (USA)": "US/Eastern",
        "Hawaii (USA)": "US/Hawaii",
        "Starke, Indiana (USA)": "US/Indiana-Starke",
        "Michigan (USA)": "US/Michigan",
        "Mountain Time Zone (USA)": "US/Mountain",
        "Pacific Time Zone (USA)": "US/Pacific",
        "Samoa (USA)": "US/Samoa",
        "Coordinated Universal Time (UTC)": "UTC",
        "West Siberian Time (Russia)": "W-SU",
        "Western European Time (WET)": "WET",
        "Ushuaia": "America/Argentina/Ushuaia",
        "Cambridge Bay": "America/Cambridge_Bay",
        "Coral Harbour": "America/Coral_Harbour",
        "Danmarkshavn": "America/Danmarkshavn",
        "Dawson Creek": "America/Dawson_Creek",
        "Eirunepe": "America/Eirunepe",
        "Glace Bay": "America/Glace_Bay",
        "Goose Bay": "America/Goose_Bay",
        "Petersburg, Indiana": "America/Indiana/Petersburg",
        "Vevay, Indiana": "America/Indiana/Vevay",
        "Vincennes, Indiana": "America/Indiana/Vincennes",
        "Winamac, Indiana": "America/Indiana/Winamac",
        "Monticello, Kentucky": "America/Kentucky/Monticello",
        "Lower Princess Quarter": "America/Lower_Princes",
        "Noronha": "America/Noronha",
        "Bowbells, North Dakota": "America/North_Dakota/Beulah",
        "Center, North Dakota": "America/North_Dakota/Center",
        "Ojinaga": "America/Ojinaga",
        "Porto Acre": "America/Porto_Acre",
        "Dumont d’Urville": "Antarctica/DumontDUrville",
        "Rothera": "Antarctica/Rothera",
        "Showa": "Antarctica/Syowa",
        "Tel Aviv (Jerusalem)": "Asia/Tel_Aviv (Jerusalem)",
        "Saint Helena": "Atlantic/St_Helena",
        "Yancowinna": "Australia/Yancowinna",
        "Fernando de Noronha": "Brazil/DeNoronha",
        "Newfoundland and Labrador": "Canada/Newfoundland",
        "Greenwich (GMT)": "GMT",
        "Comoros": "Indian/Comoro",
        "Kwajalein": "Kwajalein",
        "Mexico (Baja California)": "Mexico/BajaNorte",
        "Mexico (General Time Zone)": "Mexico/General",
        "Chatham (New Zealand)": "NZ-CHAT",
        "People's Republic of China": "PRC",
        "Pacific Standard/Daylight Time (USA & Canada)": "PST8PDT",
        "Enderbury": "Pacific/Enderbury",
        "Galápagos Islands": "Pacific/Galapagos",
        "Gambier": "Pacific/Gambier",
        "Marquesas Islands": "Pacific/Marquesas",
    },
    "ru": {
        "Москва": "Europe/Moscow",
        "Санкт-Петербург": "Europe/Moscow",
        "Екатеринбург": "Asia/Yekaterinburg",
        "Казань": "Europe/Moscow",
        "Новосибирск": "Asia/Novosibirsk",
        "Красноярск": "Asia/Krasnoyarsk",
        "Челябинск": "Asia/Yekaterinburg",
        "Омск": "Asia/Omsk",
        "Самара": "Europe/Samara",
        "Ростов-на-Дону": "Europe/Moscow",
        "Уфа": "Asia/Yekaterinburg",
        "Краснодар": "Europe/Moscow",
        "Пермь": "Asia/Yekaterinburg",
        "Владивосток": "Asia/Vladivostok",
        "Иркутск": "Asia/Irkutsk",
        "Ярославль": "Europe/Moscow",
        "Воронеж": "Europe/Moscow",
        "Махачкала": "Europe/Moscow",
        "Томск": "Asia/Novosibirsk",
        "Оренбург": "Europe/Samara",
        "Кемерово": "Asia/Novokuznetsk",
        "Тюмень": "Asia/Yekaterinburg",
        "Волгоград": "Europe/Volgograd",
        "Астрахань": "Europe/Astrakhan",
        "Киров": "Europe/Moscow",
        "Ижевск": "Europe/Samara",
        "Ульяновск": "Europe/Ulyanovsk",
        "Барнаул": "Asia/Novosibirsk",
        "Владимир": "Europe/Moscow",
        "Калининград": "Europe/Kaliningrad",
        "Нальчик": "Europe/Moscow",
        "Хабаровск": "Asia/Vladivostok",
        "Ставрополь": "Europe/Moscow",
        "Белгород": "Europe/Moscow",
        "Ханты-Мансийск": "Asia/Yekaterinburg",
        "Сургут": "Asia/Yekaterinburg",
        "Чебоксары": "Europe/Moscow",
        "Петрозаводск": "Europe/Moscow",
        "Курган": "Asia/Yekaterinburg",
        "Великий Новгород": "Europe/Moscow",
        "Кострома": "Europe/Moscow",
        "Йошкар-Ола": "Europe/Moscow",
        "Саранск": "Europe/Moscow",
        "Якутск": "Asia/Yakutsk",
        "Владикавказ": "Europe/Moscow",
        "Симферополь": "Europe/Simferopol",
        "Курск": "Europe/Moscow",
        "Мурманск": "Europe/Moscow",
        "Тамбов": "Europe/Moscow",
        "Грозный": "Europe/Moscow",
        "Тверь": "Europe/Moscow",
        "Тула": "Europe/Moscow",
        "Благовещенск": "Asia/Yakutsk",
        "Чита": "Asia/Chita",
        "Псков": "Europe/Moscow",
        "Брянск": "Europe/Moscow",
        "Рязань": "Europe/Moscow",
        "Архангельск": "Europe/Moscow",
        "Липецк": "Europe/Moscow",
        "Магадан": "Asia/Magadan",
        "Горно-Алтайск": "Asia/Omsk",
        "Сыктывкар": "Europe/Moscow",
        "Смоленск": "Europe/Moscow",
        "Биробиджан": "Asia/Vladivostok",
        "Петропавловск-Камчатский": "Asia/Kamchatka",
        "Абакан": "Asia/Krasnoyarsk",
        "Севастополь": "Europe/Simferopol",
        "Анадырь": "Asia/Anadyr",
        "Салехард": "Asia/Yekaterinburg",
        "Абиджан": "Africa/Abidjan",
        "Аккра": "Africa/Accra",
        "Аддис-Абеба": "Africa/Addis_Ababa",
        "Алжир": "Africa/Algiers",
        "Асмэра": "Africa/Asmara",
        "Бамако": "Africa/Bamako",
        "Банги": "Africa/Bangui",
        "Банджул": "Africa/Banjul",
        "Бисау": "Africa/Bissau",
        "Блантайр": "Africa/Blantyre",
        "Браззавиль": "Africa/Brazzaville",
        "Бужумбура": "Africa/Bujumbura",
        "Каир": "Africa/Cairo",
        "Касабланка": "Africa/Casablanca",
        "Сеута": "Africa/Ceuta",
        "Конакри": "Africa/Conakry",
        "Дакар": "Africa/Dakar",
        "Дар-эс-Салам": "Africa/Dar_es_Salaam",
        "Джибути": "Africa/Djibouti",
        "Дуала": "Africa/Douala",
        "Эль-Аюн": "Africa/El_Aaiun",
        "Фритаун": "Africa/Freetown",
        "Габороне": "Africa/Gaborone",
        "Хараре": "Africa/Harare",
        "Йоханнесбург": "Africa/Johannesburg",
        "Джуба": "Africa/Juba",
        "Кампала": "Africa/Kampala",
        "Хартум": "Africa/Khartoum",
        "Кигали": "Africa/Kigali",
        "Киншаса": "Africa/Kinshasa",
        "Лагос": "Africa/Lagos",
        "Либревиль": "Africa/Libreville",
        "Ломе": "Africa/Lome",
        "Луанда": "Africa/Luanda",
        "Лубумбаши": "Africa/Lubumbashi",
        "Лусака": "Africa/Lusaka",
        "Малабо": "Africa/Malabo",
        "Мапуту": "Africa/Maputo",
        "Масеру": "Africa/Maseru",
        "Мбабане": "Africa/Mbabane",
        "Могадишо": "Africa/Mogadishu",
        "Монровия": "Africa/Monrovia",
        "Найроби": "Africa/Nairobi",
        "Нджамена": "Africa/Ndjamena",
        "Ниамей": "Africa/Niamey",
        "Нуакшот": "Africa/Nouakchott",
        "Уагадугу": "Africa/Ouagadougou",
        "Порто-Ново": "Africa/Porto-Novo",
        "Сан-Томе": "Africa/Sao_Tome",
        "Тимбукту": "Africa/Timbuktu",
        "Триполи": "Africa/Tripoli",
        "Тунис": "Africa/Tunis",
        "Виндхук": "Africa/Windhoek",
        "Адак": "America/Adak",
        "Анкоридж": "America/Anchorage",
        "Ангилья": "America/Anguilla",
        "Антигуа": "America/Antigua",
        "Арагуаина": "America/Araguaina",
        "Буэнос-Айрес": "America/Argentina/Buenos_Aires",
        "Катамарка": "America/Argentina/Catamarca",
        "Комодоро-Ривадавия": "America/Argentina/ComodRivadavia",
        "Кордова": "America/Argentina/Cordoba",
        "Жужуй": "America/Argentina/Jujuy",
        "Ла-Риоха": "America/Argentina/La_Rioja",
        "Мендоса": "America/Argentina/Mendoza",
        "Рио-Гальегос": "America/Argentina/Rio_Gallegos",
        "Сальта": "America/Argentina/Salta",
        "Сан-Хуан": "America/Argentina/San_Juan",
        "Сан-Луис": "America/Argentina/San_Luis",
        "Тукуман": "America/Argentina/Tucuman",
        "Ушуайя": "America/Argentina/Ushuaia",
        "Аруба": "America/Aruba",
        "Асунсьон": "America/Asuncion",
        "Атикокан": "America/Atikokan",
        "Баия": "America/Bahia",
        "Баия-де-Бандерас": "America/Bahia_Banderas",
        "Барбадос": "America/Barbados",
        "Белен": "America/Belem",
        "Белиз": "America/Belize",
        "Бланк-Саблон": "America/Blanc-Sablon",
        "Боа-Виста": "America/Boa_Vista",
        "Богота": "America/Bogota",
        "Бойсе": "America/Boise",
        "Кембридж-Бей": "America/Cambridge_Bay",
        "Кампу-Гранди": "America/Campo_Grande",
        "Канкун": "America/Cancun",
        "Каракас": "America/Caracas",
        "Кайенна": "America/Cayenne",
        "Кайман": "America/Cayman",
        "Чикаго": "America/Chicago",
        "Чиуауа": "America/Chihuahua",
        "Сьюдад-Хуарес": "America/Ciudad_Juarez",
        "Корал-Харбор": "America/Coral_Harbour",
        "Коста-Рика": "America/Costa_Rica",
        "Крестон": "America/Creston",
        "Куяба": "America/Cuiaba",
        "Кюрасао": "America/Curacao",
        "Данмарксхавн": "America/Danmarkshavn",
        "Доусон": "America/Dawson",
        "Доусон-Крик": "America/Dawson_Creek",
        "Денвер": "America/Denver",
        "Детройт": "America/Detroit",
        "Доминика": "America/Dominica",
        "Эдмонтон": "America/Edmonton",
        "Эйрунепе": "America/Eirunepe",
        "Сан-Сальвадор": "America/El_Salvador",
        "Энсенада": "America/Ensenada",
        "Форт-Нельсон": "America/Fort_Nelson",
        "Форт-Уэйн": "America/Fort_Wayne",
        "Форталеза": "America/Fortaleza",
        "Глейс-Бей": "America/Glace_Bay",
        "Нуук": "America/Godthab",
        "Гус-Бей": "America/Goose_Bay",
        "Гранд-Терк": "America/Grand_Turk",
        "Гренада": "America/Grenada",
        "Гваделупа": "America/Guadeloupe",
        "Гватемала": "America/Guatemala",
        "Гуаякиль": "America/Guayaquil",
        "Гайана": "America/Guyana",
        "Галифакс": "America/Halifax",
        "Гавана": "America/Havana",
        "Эрмосильо": "America/Hermosillo",
        "Индианаполис": "America/Indiana/Indianapolis",
        "Нокс, Индиана": "America/Indiana/Knox",
        "Маренго, Индиана": "America/Indiana/Marengo",
        "Питерсберг, Индиана": "America/Indiana/Petersburg",
        "Телл-Сити, Индиана": "America/Indiana/Tell_City",
        "Вивей, Индиана": "America/Indiana/Vevay",
        "Винсеннес, Индиана": "America/Indiana/Vincennes",
        "Винамак, Индиана": "America/Indiana/Winamac",
        "Инувик": "America/Inuvik",
        "Икалуит": "America/Iqaluit",
        "Ямайка": "America/Jamaica",
        "Джуно": "America/Juneau",
        "Луисвилл": "America/Kentucky/Louisville",
        "Монтиселло, Кентукки": "America/Kentucky/Monticello",
        "Кралендейк": "America/Kralendijk",
        "Ла-Пас": "America/La_Paz",
        "Лима": "America/Lima",
        "Лос-Анджелес": "America/Los_Angeles",
        "Лоуэр-Принсес-Квотер": "America/Lower_Princes",
        "Масейо": "America/Maceio",
        "Манагуа": "America/Managua",
        "Манаус": "America/Manaus",
        "Мариго": "America/Marigot",
        "Мартиника": "America/Martinique",
        "Матаморос": "America/Matamoros",
        "Масатлан": "America/Mazatlan",
        "Меномини": "America/Menominee",
        "Мерида": "America/Merida",
        "Метлакатла": "America/Metlakatla",
        "Мехико": "America/Mexico_City",
        "Микелон": "America/Miquelon",
        "Монктон": "America/Moncton",
        "Монтеррей": "America/Monterrey",
        "Монтевидео": "America/Montevideo",
        "Монреаль": "America/Montreal",
        "Монтсеррат": "America/Montserrat",
        "Нассау": "America/Nassau",
        "Нью-Йорк": "America/New_York",
        "Нипигон": "America/Nipigon",
        "Ном": "America/Nome",
        "Норонья": "America/Noronha",
        "Бойла, Северная Дакота": "America/North_Dakota/Beulah",
        "Центр, Северная Дакота": "America/North_Dakota/Center",
        "Нью-Салем, Северная Дакота": "America/North_Dakota/New_Salem",
        "Охинага": "America/Ojinaga",
        "Панама": "America/Panama",
        "Пангниртунг": "America/Pangnirtung",
        "Парамарибо": "America/Paramaribo",
        "Финикс": "America/Phoenix",
        "Порт-о-Пренс": "America/Port-au-Prince",
        "Порт-оф-Спейн": "America/Port_of_Spain",
        "Порту-Акри": "America/Porto_Acre",
        "Порту-Велью": "America/Porto_Velho",
        "Пуэрто-Рико": "America/Puerto_Rico",
        "Пунта-Аренас": "America/Punta_Arenas",
        "Рейни-Ривер": "America/Rainy_River",
        "Ранкин-Инлет": "America/Rankin_Inlet",
        "Ресифи": "America/Recife",
        "Реджайна": "America/Regina",
        "Резольют": "America/Resolute",
        "Риу-Бранку": "America/Rio_Branco",
        "Росарио": "America/Rosario",
        "Санта-Изабел": "America/Santa_Isabel",
        "Сантарен": "America/Santarem",
        "Сантьяго": "America/Santiago",
        "Санто-Доминго": "America/Santo_Domingo",
        "Сан-Паулу": "America/Sao_Paulo",
        "Иттоккортоормиит": "America/Scoresbysund",
        "Шипрок": "America/Shiprock",
        "Ситка": "America/Sitka",
        "Сен-Бартелеми": "America/St_Barthelemy",
        "Сент-Джонс": "America/St_Johns",
        "Сент-Китс": "America/St_Kitts",
        "Сент-Люсия": "America/St_Lucia",
        "Сент-Томас": "America/St_Thomas",
        "Сент-Винсент": "America/St_Vincent",
        "Свифт-Каррент": "America/Swift_Current",
        "Тегусигальпа": "America/Tegucigalpa",
        "Туле": "America/Thule",
        "Тандер-Бей": "America/Thunder_Bay",
        "Тихуана": "America/Tijuana",
        "Торонто": "America/Toronto",
        "Тортола": "America/Tortola",
        "Ванкувер": "America/Vancouver",
        "Вирджин": "America/Virgin",
        "Уайтхорс": "America/Whitehorse",
        "Виннипег": "America/Winnipeg",
        "Якутат": "America/Yakutat",
        "Йеллоунайф": "America/Yellowknife",
        "Кейси": "Antarctica/Casey",
        "Дэвис": "Antarctica/Davis",
        "Дюмон-д’Юрвиль": "Antarctica/DumontDUrville",
        "Маккуори": "Antarctica/Macquarie",
        "Моусон": "Antarctica/Mawson",
        "Мак-Мердо": "Antarctica/McMurdo",
        "Палмер": "Antarctica/Palmer",
        "Ротера": "Antarctica/Rothera",
        "Южный полюс": "Antarctica/South_Pole",
        "Сёва": "Antarctica/Syowa",
        "Тролл": "Antarctica/Troll",
        "Восток": "Antarctica/Vostok",
        "Лонгйир": "Arctic/Longyearbyen",
        "Аден": "Asia/Aden",
        "Алматы": "Asia/Almaty",
        "Амман": "Asia/Amman",
        "Актау": "Asia/Aqtau",
        "Актобе": "Asia/Aqtobe",
        "Ашхабад": "Asia/Ashgabat",
        "Атырау": "Asia/Atyrau",
        "Багдад": "Asia/Baghdad",
        "Бахрейн": "Asia/Bahrain",
        "Баку": "Asia/Baku",
        "Бангкок": "Asia/Bangkok",
        "Бейрут": "Asia/Beirut",
        "Бишкек": "Asia/Bishkek",
        "Бруней": "Asia/Brunei",
        "Калькутта (Колката)": "Asia/Calcutta (Kolkata)",
        "Чойбалсан": "Asia/Choibalsan",
        "Чунцин": "Asia/Chongqing (Chungking)",
        "Коломбо": "Asia/Colombo",
        "Дакка (Дака)": "Asia/Dacca (Dhaka)",
        "Дамаск": "Asia/Damascus",
        "Дака": "Asia/Dhaka",
        "Дили": "Asia/Dili",
        "Дубай": "Asia/Dubai",
        "Душанбе": "Asia/Dushanbe",
        "Фамагуста": "Asia/Famagusta",
        "Газа": "Asia/Gaza",
        "Харбин": "Asia/Harbin",
        "Хеврон": "Asia/Hebron",
        "Хошимин": "Asia/Ho_Chi_Minh",
        "Гонконг": "Asia/Hong_Kong",
        "Ховд": "Asia/Hovd",
        "Стамбул": "Asia/Istanbul",
        "Джакарта": "Asia/Jakarta",
        "Джаяпура": "Asia/Jayapura",
        "Иерусалим": "Asia/Jerusalem",
        "Кабул": "Asia/Kabul",
        "Камчатка": "Asia/Kamchatka",
        "Карачи": "Asia/Karachi",
        "Кашгар": "Asia/Kashgar",
        "Катманду": "Asia/Kathmandu",
        "Хандыга": "Asia/Khandyga",
        "Колката": "Asia/Kolkata",
        "Куала-Лумпур": "Asia/Kuala_Lumpur",
        "Кучинг": "Asia/Kuching",
        "Кувейт": "Asia/Kuwait",
        "Макао": "Asia/Macao (Macau)",
        "Макассар": "Asia/Makassar",
        "Манила": "Asia/Manila",
        "Маскат": "Asia/Muscat",
        "Никосия": "Asia/Nicosia",
        "Новокузнецк": "Asia/Novokuznetsk",
        "Уральск": "Asia/Oral",
        "Пномпень": "Asia/Phnom_Penh",
        "Понтианак": "Asia/Pontianak",
        "Пхеньян": "Asia/Pyongyang",
        "Катар": "Asia/Qatar",
        "Костанай": "Asia/Qostanay (Kostanay)",
        "Кызылорда": "Asia/Qyzylorda",
        "Янгон": "Asia/Rangoon (Yangon)",
        "Эр-Рияд": "Asia/Riyadh",
        "Сахалин": "Asia/Sakhalin",
        "Самарканд": "Asia/Samarkand",
        "Сеул": "Asia/Seoul",
        "Шанхай": "Asia/Shanghai",
        "Сингапур": "Asia/Singapore",
        "Среднеколымск": "Asia/Srednekolymsk",
        "Тайбэй": "Asia/Taipei",
        "Ташкент": "Asia/Tashkent",
        "Тбилиси": "Asia/Tbilisi",
        "Тегеран": "Asia/Tehran",
        "Тель-Авив (Иерусалим)": "Asia/Tel_Aviv (Jerusalem)",
        "Тхимпху": "Asia/Thimbu (Thimphu)",
        "Токио": "Asia/Tokyo",
        "Улан-Батор": "Asia/Ulaanbaatar (Ulan Bator)",
        "Урумчи": "Asia/Urumqi",
        "Усть-Нера": "Asia/Ust-Nera",
        "Вьентьян": "Asia/Vientiane",
        "Ереван": "Asia/Yerevan",
        "Азорские острова": "Atlantic/Azores",
        "Бермудские острова": "Atlantic/Bermuda",
        "Канарские острова": "Atlantic/Canary",
        "Кабо-Верде": "Atlantic/Cape_Verde",
        "Фарерские острова": "Atlantic/Faeroe (Faroe)",
        "Ян-Майен": "Atlantic/Jan_Mayen",
        "Мадейра": "Atlantic/Madeira",
        "Рейкьявик": "Atlantic/Reykjavik",
        "Южная Георгия": "Atlantic/South_Georgia",
        "Святая Елена": "Atlantic/St_Helena",
        "Стэнли": "Atlantic/Stanley",
        "Аделаида": "Australia/Adelaide",
        "Брисбен": "Australia/Brisbane",
        "Брокен-Хилл": "Australia/Broken_Hill",
        "Карри": "Australia/Currie",
        "Дарвин": "Australia/Darwin",
        "Юкла": "Australia/Eucla",
        "Хобарт": "Australia/Hobart",
        "Линдеман": "Australia/Lindeman",
        "Лорд-Хау": "Australia/Lord_Howe",
        "Мельбурн": "Australia/Melbourne",
        "Перт": "Australia/Perth",
        "Сидней": "Australia/Sydney",
        "Янкауинна": "Australia/Yancowinna",
        "Акри": "Brazil/Acre",
        "Фернанду-ди-Норонья": "Brazil/DeNoronha",
        "Бразилия (восточная часть)": "Brazil/East",
        "Бразилия (западная часть)": "Brazil/West",
        "Канада (Атлантический часовой пояс)": "Canada/Atlantic",
        "Канада (Центральный часовой пояс)": "Canada/Central",
        "Канада (Восточный часовой пояс)": "Canada/Eastern",
        "Канада (Горный часовой пояс)": "Canada/Mountain",
        "Ньюфаундленд и Лабрадор": "Canada/Newfoundland",
        "Канада (Тихоокеанский часовой пояс)": "Canada/Pacific",
        "Саскачеван": "Canada/Saskatchewan",
        "Юкон": "Canada/Yukon",
        "Чили (континентальная часть)": "Chile/Continental",
        "Пасхи остров": "Chile/EasterIsland",
        "Куба": "Cuba",
        "Египет": "Egypt",
        "Ирландия": "Eire",
        "Гринвич (GMT)": "GMT",
        "Исландия": "Iceland",
        "Антананариву": "Indian/Antananarivo",
        "Чагос": "Indian/Chagos",
        "Остров Рождества": "Indian/Christmas",
        "Кокосовые острова": "Indian/Cocos",
        "Коморские острова": "Indian/Comoro",
        "Кергелен": "Indian/Kerguelen",
        "Маэ": "Indian/Mahe",
        "Мальдивы": "Indian/Maldives",
        "Маврикий": "Indian/Mauritius",
        "Майотта": "Indian/Mayotte",
        "Реюньон": "Indian/Reunion",
        "Иран": "Iran",
        "Израиль": "Israel",
        "Япония": "Japan",
        "Кваджалейн": "Kwajalein",
        "Ливия": "Libya",
        "Мексика (Северная Нижняя Калифорния)": "Mexico/BajaNorte",
        "Мексика (Южная Нижняя Калифорния)": "Mexico/BajaSur",
        "Мексика (общий часовой пояс)": "Mexico/General",
        "Новая Зеландия": "NZ",
        "Чатем (Новая Зеландия)": "NZ-CHAT",
        "Навахо": "Navajo",
        "Китайская Народная Республика": "PRC",
        "Тихоокеанский стандартный/летний час (США и Канада)": "PST8PDT",
        "Апиа": "Pacific/Apia",
        "Окленд": "Pacific/Auckland",
        "Бугенвиль": "Pacific/Bougainville",
        "Чатем": "Pacific/Chatham",
        "Чуук (Трук)": "Pacific/Chuuk (Truk)",
        "Эфате": "Pacific/Efate",
        "Эндербери": "Pacific/Enderbury",
        "Факаофо": "Pacific/Fakaofo",
        "Фиджи": "Pacific/Fiji",
        "Фунафути": "Pacific/Funafuti",
        "Галапагосские острова": "Pacific/Galapagos",
        "Гамбье": "Pacific/Gambier",
        "Гуадалканал": "Pacific/Guadalcanal",
        "Гуам": "Pacific/Guam",
        "Гонолулу": "Pacific/Honolulu",
        "Джонстон": "Pacific/Johnston",
        "Кантон": "Pacific/Kanton",
        "Киритимати": "Pacific/Kiritimati",
        "Косрае": "Pacific/Kosrae",
        "Маджуро": "Pacific/Majuro",
        "Маркизские острова": "Pacific/Marquesas",
        "Мидуэй": "Pacific/Midway",
        "Науру": "Pacific/Nauru",
        "Ниуэ": "Pacific/Niue",
        "Норфолк": "Pacific/Norfolk",
        "Нумеа": "Pacific/Noumea",
        "Паго-Паго": "Pacific/Pago_Pago",
        "Палау": "Pacific/Palau",
        "Питкэрн": "Pacific/Pitcairn",
        "Понпеи": "Pacific/Pohnpei (Ponape)",
        "Порт-Морсби": "Pacific/Port_Moresby",
        "Раротонга": "Pacific/Rarotonga",
        "Сайпан": "Pacific/Saipan",
        "Самоа": "Pacific/Samoa",
        "Таити": "Pacific/Tahiti",
        "Тарава": "Pacific/Tarawa",
        "Тонгатапу": "Pacific/Tongatapu",
        "Уэйк": "Pacific/Wake",
        "Уоллис": "Pacific/Wallis",
        "Яп": "Pacific/Yap",
        "Польша": "Poland",
        "Португалия": "Portugal",
        "Турция": "Turkey",
        "Аляска (США)": "US/Alaska",
        "Алеутские острова (США)": "US/Aleutian",
        "Аризона (США)": "US/Arizona",
        "Центральный часовой пояс (США)": "US/Central",
        "Восточная Индиана (США)": "US/East-Indiana",
        "Восточный часовой пояс (США)": "US/Eastern",
        "Гавайи (США)": "US/Hawaii",
        "Старк, Индиана (США)": "US/Indiana-Starke",
        "Мичиган (США)": "US/Michigan",
        "Горный часовой пояс (США)": "US/Mountain",
        "Тихоокеанский часовой пояс (США)": "US/Pacific",
        "Самоа (США)": "US/Samoa",
        "Всемирное координированное время (UTC)": "UTC",
        "Западно-Сибирское время (Россия)": "W-SU",
        "Западноевропейское время (WET)": "WET",
    },
};
